export const fetchNewSessionId = async (baseUrl) => {
  const tokenStr = localStorage.getItem("access_token");
  const response = await fetch(`${baseUrl}chat/session/new-session-id`, {
    method: "GET", 
    headers: {
      Authorization: `Bearer ${tokenStr}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch new session ID: ${response.status}`);
  }

  const data = await response.json();
  if (!data.session_id) {
    throw new Error("Backend response missing session_id");
  }

  return data.session_id;
};

export const extractDownloadUrl = (text) => {
  if (!text) return null;
  const match = text.match(/https?:\/\/[^\s]*\/chat\/report\/download[^\s]*/);
  return match ? match[0].replace(/[\s\n\r]+$/, "") : null;
};

export const extractFileType = (text) => {
  if (!text) return null;
  const formatMatch = text.match(/[?&]format=(xlsx|pdf)/i);
  if (formatMatch)
    return formatMatch[1].toLowerCase() === "pdf" ? "pdf" : "excel";
  const lower = text.toLowerCase();
  if (lower.includes("pdf")) return "pdf";
  if (lower.includes("excel") || lower.includes("xlsx")) return "excel";
  return null;
};

export const normalizeAgent = (value) =>
  value ? String(value).trim().toLowerCase() : null;

export const parseAgentFromStatus = (text = "") => {
  const m = text.match(/transferring your request to the\s+(\w+)\s+agent/i);
  return m ? normalizeAgent(m[1]) : null;
};

export const formatMessageTimestamp = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const mapTurnsToMessages = (turns = []) => {
  const messages = [];
  turns.forEach((turn, idx) => {
    if (turn.user_query) {
      messages.push({
        id: `turn-${idx}-user`,
        sender: "user",
        text: turn.user_query,
      });
    }
    if (turn.response) {
      const downloadUrl = extractDownloadUrl(turn.response);
      const fileType = downloadUrl
        ? extractFileType(downloadUrl)
        : extractFileType(turn.response);
      const duplicateGroups =
        turn.duplicate_groups || turn.dublicate_groups || null;

      messages.push({
        id: `turn-${idx}-agent`,
        sender: "agent",
        aiAgent: normalizeAgent(turn.ai_agent),
        timestamp: turn.timestamp || null,
        text: downloadUrl
          ? turn.response
              .replace(downloadUrl, "")
              .replace(/\n{2,}/g, "\n")
              .trim()
          : turn.response,
        ...(downloadUrl && { downloadUrl, fileType: fileType || "excel" }),
        ...(duplicateGroups && { duplicateGroups }),
        ...(turn.audit_id != null && { auditId: turn.audit_id }),
      });
    }
  });
  return messages;
};